import { RootState } from 'store/root-reducer';

export const getErrors = (state: RootState): any | null => state.admin.lanes.error;
export const getResult = (state: RootState): any | null => state.admin.lanes.result;
export const getLanes = (state: RootState): any | null => state.admin.lanes.types;
